type RequiredKey =
  | 'REACT_APP_NODE_ENV'
  | 'REACT_APP_APP_ENV'
  | 'REACT_APP_FRONTEND_URL'
  | 'REACT_APP_API_BASE_URL'
  | 'REACT_APP_USER_SERVICE_URL'
  | 'REACT_APP_AI_SERVICE_URL';

const readRequired = (key: RequiredKey): string => {
  const value = process.env[key];
  if (!value || !value.trim()) {
    throw new Error(`Missing required environment variable: ${key}`);
  }

  return value.trim();
};

export const webConfig = {
  nodeEnv: readRequired('REACT_APP_NODE_ENV'),
  appEnv: readRequired('REACT_APP_APP_ENV'),
  frontendUrl: readRequired('REACT_APP_FRONTEND_URL'),
  apiBaseUrl: readRequired('REACT_APP_API_BASE_URL'),
  userServiceUrl: readRequired('REACT_APP_USER_SERVICE_URL'),
  aiServiceUrl: readRequired('REACT_APP_AI_SERVICE_URL'),
};

export type WebConfig = typeof webConfig;
